module.exports = __webpack_public_path__ + "static/media/logoutExpiryAccount.2f56fcde.svg";